import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=78681097&scoped=true"
import script from "./ProviderList.vue?vue&type=script&lang=js"
export * from "./ProviderList.vue?vue&type=script&lang=js"
import style0 from "./ProviderList.vue?vue&type=style&index=0&id=78681097&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78681097",
  null
  
)

export default component.exports